import { useTranslation } from "react-i18next";

import { MeasurementType } from "../../shared/enums/Result";
import { VPISMeasurement } from "../../shared/interfaces/Result";

import { Card } from "../../shared/Card";
import { FormRow } from "../../shared/FormLayout/FormRow";

import { useInternationalFormatters } from "../../shared/helpers/useInternationalFormatters";

interface VPISMeasurementCardProps {
  measurement: VPISMeasurement;
}

export function VPISMeasurementCard(props: VPISMeasurementCardProps) {
  const { t } = useTranslation();
  const { formatNumber } = useInternationalFormatters();

  return (
    <Card
      title={t("results.measurementType", {
        measurementType: `$t(MeasurementTypes.${MeasurementType.VPIS} )`,
      })}
      className="mb-3"
    >
      <FormRow label={t("measurements.MeasureMV")} value={props.measurement.MeasureMV} />
      <FormRow
        label={t("measurements.MeasurePPC")}
        value={props.measurement.MeasurePPC && formatNumber(props.measurement.MeasurePPC, 3)}
      />
      <FormRow
        label={t("measurements.PhaseReferenceLock")}
        value={props.measurement.PhaseReferenceLock ? t("common.true") : t("common.false")}
      />
      <FormRow
        label={t("measurements.PhaseReferenceType")}
        value={props.measurement.PhaseReferenceType && t(`PhaseReferenceType.${props.measurement.PhaseReferenceType}`)}
      />
    </Card>
  );
}
